import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Carousel, Arrows, Track, Slide } from '@fiverr-private/carousel';
import { getContext } from '@fiverr-private/fiverr_context';
import { NavigationCard } from '../../cards';
import { CustomArrows } from './CustomArrows';
import { NavigationCardCarouselProps } from './NavigationCardCarousel.types';

export const NavigationCardCarousel: React.FC<NavigationCardCarouselProps> = ({
    tiles,
    title,
    description,
    textColor = 'black',
    cardSize = 'sm',
    arrowBtnVariant = 'primary',
    carouselProps,
    carouselTrackProps,
    biEventData,
}) => {
    const hasHeader = title || description;

    const { isMobile = false } = getContext();

    return (
        <Stack direction="column" position="relative" height="100%" gap="5" maxWidth="min-content" {...carouselProps}>
            <Carousel
                breakpoints={{
                    default: 4,
                }}
            >
                {hasHeader && (
                    <Stack alignItems="center" justifyContent="spaceBetween" marginBottom="6" minHeight="34px">
                        <Stack direction="column" gap="1">
                            {title && (
                                <Typography as="h4" color={textColor}>
                                    {title}
                                </Typography>
                            )}
                            {description && (
                                <Typography fontSize="b_lg" lineHeight="b_lg" color={textColor}>
                                    {description}
                                </Typography>
                            )}
                        </Stack>
                        {!isMobile && <CustomArrows arrowBtnVariant={arrowBtnVariant} />}
                    </Stack>
                )}
                {!hasHeader && <Arrows />}
                <Track slidesGap="4" autoSlidesWidth {...carouselTrackProps}>
                    {tiles.map((props) => (
                        <Slide key={`navigation-card-${props.title}`}>
                            <NavigationCard cardSize={cardSize} biEventData={biEventData} {...props} />
                        </Slide>
                    ))}
                </Track>
            </Carousel>
        </Stack>
    );
};
